import React from 'react'
import PropTypes from 'prop-types';
import TransferList from './transferList/TransferList';
import Form from 'components/Form';
import * as Yup from 'yup'
import ValidationShema from 'constants/ValidationShema';
import {POSITION_VALUE} from 'constants/PositionItems'
import Loading from "components/Loading";
import SaveFormikValues from "components/SaveFormikValues";
import AutoSaveFormValues from "components/AutoSaveFormValues";

function CommissionForm(
    {
        formId,
        demandId,
        commissionUserList,
        userListAvailable,
        establishmentDate,
        handleSubmit,
        afterSubmitFunc = () => {
        },
        editable,
        doLoadHistory,
        markHistorical,
        saveDraftFunc,
        autoSaveFormDraftActive
    }) {

    const validationSchema = () => {
        return Yup.object().shape({
            users: Yup.array().of(
                Yup.lazy((value) => {
                    if (value.role === POSITION_VALUE.OTHER) {
                        return Yup.object().shape({
                            otherRole: ValidationShema.string().nullable()
                        })
                    }
                    return Yup.object().shape({})
                })
            ),
            establishmentDate: ValidationShema.any()
        })
    }

    const getInitValues = () => {
        return {
            _editable: editable,
            users: [...commissionUserList],
            establishmentDate: establishmentDate,
        }
    }

    if (!userListAvailable || !commissionUserList) return <Loading/>
    return (
        <Form
            initialValues={getInitValues()}
            id={formId}
            validationSchema={validationSchema()}
            onSubmit={handleSubmit}
            afterSubmitFunc={afterSubmitFunc}
        >
            {(formikProps) => (
                <>
                    <SaveFormikValues
                        formikProps={formikProps}
                        id={formId}
                    />

                    {!!saveDraftFunc && !!autoSaveFormDraftActive &&
                    <AutoSaveFormValues
                        formikProps={formikProps}
                        id={demandId}
                        formId={formId}
                        saveFunc={(formValues) => {
                            saveDraftFunc(demandId, formValues)
                        }}
                    />
                    }

                    <TransferList
                        doLoadHistory={doLoadHistory}
                        formikProps={formikProps}
                        userListAvailable={userListAvailable}
                        markHistorical={markHistorical}
                    />
                </>
            )}
        </Form>
    )
}

CommissionForm.propTypes = {
    classes: PropTypes.any,
}

export default CommissionForm;
